import { RouteItem } from '@eastcoal/router/types/route'

import { SECRET_AUCTION_SALE_LIST_PAGE_PATH } from './constants/path'

export const secretAuctionSaleListRoute: RouteItem = {
  title: '密函',
  path: SECRET_AUCTION_SALE_LIST_PAGE_PATH,
  Component: () => import('./index')
}
